import styled from "styled-components"

export const CheckboxContainer = styled.div`
  cursor: pointer;
  input {
    transform: scale(1.5);
    margin-right: 0.5rem;
  }
`
